import { Subscription } from 'rxjs';

import { Injectable, Type } from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasOptions, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
	providedIn: 'root',
})
export class OffcanvasService {
	private offcanvasStack: Array<{ ref: NgbOffcanvasRef; sub: Subscription }> = [];

	constructor(private offcanvasService: NgbOffcanvas) {}

	open(
		content: Type<unknown>,
		position: 'start' | 'end' | 'top' | 'bottom' = 'end',
		backdrop: boolean = true,
		size: 'oc-sm' | 'oc-md' | 'oc-lg' | 'oc-xl' | 'oc-90' = 'oc-md',
		shouldClose?: () => boolean | Promise<boolean>,
	): NgbOffcanvasRef {
		const options: NgbOffcanvasOptions = {
			position,
			backdrop,
			ariaLabelledBy: 'offcanvas-title',
			panelClass: size,
			beforeDismiss: shouldClose,
		};

		const ref = this.offcanvasService.open(content, options);
		const sub = ref.dismissed.subscribe(() => this.close(ref));
		this.offcanvasStack.push({ ref, sub });

		return ref;
	}

	dismissLast(): void {
		if (this.offcanvasStack.length > 0) {
			const { ref } = this.offcanvasStack[this.offcanvasStack.length - 1];
			ref.dismiss();
		}
	}

	hasOpenOffcanvas(): boolean {
		return this.offcanvasStack.length > 0;
	}

	private close(ref?: NgbOffcanvasRef): void {
		const index = ref ? this.offcanvasStack.findIndex((item) => item.ref === ref) : this.offcanvasStack.length - 1;

		if (index >= 0) {
			const { ref: offcanvasRef, sub } = this.offcanvasStack.splice(index, 1)[0];
			sub.unsubscribe();
			offcanvasRef.close();
		}
	}
}
